// lang-fr.ts

export const LANG_FR_NAME = 'fr';

export const LANG_FR_TRANS = {
  'Rechercher... ex.(Numéro de voyage...)': 'Rechercher... ex.(Numéro de voyage...)',
  'Liste des voyages': 'Liste des voyages',
  'Liste des trajets': 'Liste des trajets',
  'Gestion des utilisateurs': 'Gestion des utilisateurs',
  'Gestion des clients': 'Gestion des clients',
  'Gestion des chauffeurs': 'Gestion des chauffeurs',
  'Gestion des tracteurs': 'Gestion des tracteurs',
  'Gestion des Remorques': 'Gestion des Remorques',
  'Points de contrôle': 'Points de contrôle',
  'Statistiques': 'Statistiques',
  'Configurations': 'Configurations',
  'Déconnexion': 'Déconnexion',

  'Dashboard': 'Dashboard',
  'Pages': 'Pages',
  'Filtre': 'Filtre',
  'Numéro du voyage ou WPT': 'Numéro du voyage ou WPT',
  'Date et heure de départ': 'Date et heure de départ',
  'Date Départ': 'Date Départ',
  'Date Arrivée': 'Date Arrivée',
  'Date': 'Date',
  'Statut': 'Statut',
  'Complété': 'Complété',
  'COMPLÉTÉ': 'COMPLÉTÉ',
  'Planifié': 'Planifié',
  'En cours': 'En cours',
  'EN COURS': 'EN COURS',
  'Sans valeur': 'Sans valeur',
  'N° Chauffeur,Tracteur,Remorque': 'N° Chauffeur,Tracteur,Remorque',
  'Chauffeur': 'Chauffeur',
  'Tracteur': 'Tracteur',
  'Remorque': 'Remorque',
  'Choisir': 'Choisir',
  'Ville de Départ et Arrivée': 'Ville de Départ et Arrivée',
  'Ville Départ': 'Ville Départ',
  'Ville Arrivée': 'Ville Arrivée',

  'Administrateur': 'Administrateur',
  'admin': 'Administrateur',
  'user': 'Utilisateur',

  'De': 'De',
  'À': 'À',
  'Le': 'Le',
  'PLANIFIÉ': 'PLANIFIÉ',
  'Editer': 'Editer',
  'Détails': 'Détails',
  'Trajet': 'Trajet',
  'effectué': 'effectué',
  'En attente': 'En attente',

  'Détail du voyage': 'Détail du voyage',
  'Détail du trajet': 'Détail du trajet',
  'Etat du voyage': 'Etat du voyage',
  'Etat du trajet': 'Etat du trajet',
  'Type de Voyage': 'Type de Voyage',
  'Client': 'Client',
  'Nature': 'Nature',
  'Agrandir la carte': 'Agrandir la carte',
  'SUIVI DU VOYAGE': 'SUIVI DU VOYAGE',
  'Nombre de WPT': 'Nombre de WPT',
  'DOCUMENTS WPT': 'DOCUMENTS WPT',
  'Type': 'Type',
  'Chargement': 'Chargement',
  'Déchargement': 'Déchargement',
  'Passage': 'Passage',
  'Liste des utilisateurs': 'Liste des utilisateurs',
  'Ajouter un utilisateur': 'Ajouter un utilisateur',
  'Recherche par matricule': 'Recherche par matricule',
  'Numéro User': 'Numéro User',
  'Nom': 'Nom',
  'Prénom': 'Prénom',
  'Login': 'Login',
  'Options': 'Options',
  'Email': 'Email',
  'Liste des clients': 'Liste des clients',
  'Ajouter un client': 'Ajouter un client',
  'Numéro client': 'Numéro client',
  'Nom client': 'Nom client',
  'Lier': 'Lier',
  'Recherche par nom client': 'Recherche par nom client',
  'Nom d\'utilisateur': 'Nom d\'utilisateur',
  'Mot de passe': 'Mot de passe',
  'Se connecter': 'Se connecter',
  'Mot de passe oublié': 'Mot de passe oublié',
  'Connexion en cours': 'Connexion en cours',
  'Liste des conducteurs': 'Liste des conducteurs',
  'Ajouter un conducteur': 'Ajouter un conducteur',

  'Numéro conducteur': 'NUMERO CONDUCTOR',
  'Nom conducteur': 'Nom conducteur',
  'Code': 'Code',
  'Code Département': 'Code Département',
  'Code Département Société': 'Code Département Société',
  'Recherche par nom conducteur': 'Recherche par nom conducteur',
  'Supprimer': 'Supprimer',
  'Liste des tractors': 'Liste des tractors',
  'Ajouter un tractor': 'Ajouter un tractor',
  'Numéro Tractor': 'Numéro Tractor',
  'Matricule': 'Matricule',
  'Liste des remorques': 'Liste des remorques',
  'Ajouter une remorque': 'Ajouter une remorque',
  'Numéro Remorque': 'Numéro Remorque',
  'Type de vehicule': 'Type de vehicule',
  'Point de contrôle': 'Point de contrôle',
  'Recherche par nom du point de contrôle': 'Recherche par nom du point de contrôle',
  'Qualification': 'Qualification',
  'Photo': 'Photo',
  'Description': 'Description',

  'Liste des configurations': 'Liste des configurations',
  'Fréquence de pull': 'Fréquence de pull',
  'Numéro urgence': 'Numéro urgence',
  'Message urgence': 'Message urgence',
  'Enregistrer': 'Enregistrer',


  'En minutes': 'En minutes',
  'voir l\'image': 'voir l\'image',
  'Afficher': 'Afficher',
  'Vitesse': 'Vitesse',

  'Modification des données du client': 'Modification des données du client',
  'Ajout d\'un nouveau client': 'Ajout d\'un nouveau client',
  'client updated': 'client updated',
  'Le Nom client est obligatoire': 'Le Nom client est obligatoire',
  'Fermer': 'Fermer',
  'Close': 'Fermer',

  'Modification des données du conducteur': 'Modification des données du conducteur',
  'Ajout d\'un nouveau conducteur': 'Ajout d\'un nouveau conducteur',
  'conductor updated': 'conductor updated',
  'Numéro Conductor': 'Numéro Conductor',
  'Nom Conductor': 'Nom Conductor',
  'Code société': 'Code société',
  'Le login est obligatoire': 'Le login est obligatoire',

  'NOUVEAU POINT DE CONTRÔLE': 'NOUVEAU POINT DE CONTRÔLE',
  'MIS A JOUR DU POINT DE CONTRÔLE': 'MIS A JOUR DU POINT DE CONTRÔLE',
  'Données enregistrées': 'Données enregistrées',
  'Le nom du point de contrôle existe déjà': 'Le nom du point de contrôle existe déjà',
  'Données non enregistrées': 'Données non enregistrées',
  'Nom du point de contrôle': 'Nom du point de contrôle',
  'Le Nom du point de contrôle est obligatoire': 'Le Nom du point de contrôle est obligatoire',
  'Type de contrôle': 'Type de contrôle',
  'OK': 'OK',
  'Non OK': 'Non OK',
  'Valeur(s)': 'Valeur(s)',
  'Valeur': 'Valeur',
  'Le type de contrôle est obligatoire': 'Le type de contrôle est obligatoire',
  'Ajouter une valeur': 'Ajouter une valeur',
  'Choisir une image': 'Choisir une image',


  'Modification des données de la remorque': 'Modification des données de la remorque',
  'Ajout d\'une nouvelle remorque': 'Ajout d\'une nouvelle remorque',
  'Remorque updated': 'Remorque updated',
  'Le matricule ne doit pas dépasser 16 caractères': 'Le matricule ne doit pas dépasser 16 caractères',
  'successfully': 'succès',
  'ERROR': 'ERREUR',
  'INTERNAL_ERROR': 'Erreur interne, veuillez reessayer plus tard !',
  'Type remorque': 'Type remorque',
  'Longitude': 'Longitude',
  'Latitude': 'Latitude',
  'incorrecte': 'incorrecte',
  'Exemple': 'Exemple',
  'Choisir sur la carte': 'Choisir sur la carte',

  'Modification des données du tracteur': 'Modification des données du tracteur',
  'Ajout d\'un nouveau tracteur': 'Ajout d\'un nouveau tracteur',
  'tractor updated': 'tractor updated',
  'Numéro Tracteur': 'Numéro Tracteur',
  'ID de l\'appareil': 'ID de l\'appareil',
  'Incorrecte! ID doit être alphanumérique': 'Incorrecte! ID doit être alphanumérique',

  'Modification des données du véhicule': 'Modification des données du véhicule',
  'Ajout d\'un nouveau type véhicule': 'Ajout d\'un nouveau type véhicule',
  'Type ajouté': 'Type ajouté',
  'Le Nom est obligatoire': 'Le Nom est obligatoire',
  'Contacter': 'Contacter',
  'Alarme': 'Alarme',
  'DOCUMENTS VOYAGE': 'DOCUMENTS VOYAGE',
  'Département': 'Département',
  'Département société': 'Département société',
  'Documents liés au voyage': 'Documents liés au voyage',
  'Télécharger': 'Télécharger',
  'Image': 'Image',
  'Liste des chauffeurs liés au voyage': 'Liste des chauffeurs liés au voyage',
  'Liste des Tracteurs liés au voyage': 'Liste des Tracteurs liés au voyage',
  'Liste des Remorques liés au voyage': 'Liste des Remorques liés au voyage',
  'Liste des Clients liés au voyage': 'Liste des Clients liés au voyage',
  'MAP TRACKING': 'MAP TRACKING',
  'ETAT DU WORKFLOW': 'ETAT DU WORKFLOW',
  'Valider': 'Valider',
  'Annuler': 'Annuler',
  'Valider tous': 'Valider tous',
  'Liste des chargements': 'Liste des chargements',
  'Liste des déchargements': 'Liste des déchargements',
  'Chargement pour le client': 'Chargement pour le client',
  'Déchargement pour le client': 'Déchargement pour le client',
  'Adresse': 'Adresse',
  'Bougez le marker pour en déduire les coordonnées': 'Bougez le marker pour en déduire les coordonnées',
  'Recherche': 'Recherche',
  'Points de contrôle pour': 'Points de contrôle pour',
  'Tous les points de contrôle': 'Tous les points de contrôle',
  'Next': 'Suivant',
  'Previous': 'Précédent',
  'Loading': 'Chargement en cours',
  'TripNotStartedYet': 'Le voyage n’a pas encore démarré',
  'Depart': 'Départ',
  'Arrivee': 'Arrivée',
  'Localiser': 'Localiser',
  'UnavailableConductorPosition': 'Position du conducteur indisponible',
  'InvalideDate': 'Date incorrecte',
  'Réclamations': 'Réclamations',

  'Référence': 'Référence',
  'Sélectionner': 'Sélectionner',
  'Clôturée': 'Clôturée',
  'A réparer': 'A réparer',
  'Emetteur': 'Emetteur',
  'Document': 'Document',
  'Pas de résultats': 'Pas de résultats',
  'defaultPwdMobile': 'Mot de passe par défaut',
  'En ligne': 'En ligne',
  'Hors ligne': 'Hors ligne',
  'Messages non lus': 'Messages non lus',
  'Ecrire quelque chose ...': 'Ecrire quelque chose ...',


  //translate abdelfaah
  //tip:
   // create:
      'type_trip': 'Type de voyage',
      'end': 'Fin',
      'choose_command':'Choisir une/des commande(s)',
      'add_order':'Ajouter une commande',
      'points_departure_arrival':'Points de départ / arrivé',
      'the':'Le',
      'from':'De',
      'driving':'Conduite',
      'transit':'Transit',
      'summary':'Récapitulatif',
      'total':'Total',
      'total_driving':'Total conduite',
      'total_transit':'Total transit',
      'cancel':'Annuler',
      'validate':'Valider',
      'trips':'Trajets',
  //road{
    //list && create
      'number_trips':'Nombre de Trajets',
      'en_vigeur':'En vigueur',
      'customers' : 'Clients',
      'at': 'à',
      'points_controls':'Points de controls',
      'points_repos':'Points de repos',
      'frontiers':'',
      'pays':'Pays',
      'deviser':'Deviser',
      'routier':'Routier',
      'modifier_route':'Modifier la route',
      'ajouter_trajet':'Ajouter un trajet',
      'point_depart':'Point de départ',
      'point_arrive':'Point arrivé',
      'nombre_trajets':'Nombre de trajets',
      't.conduite':'T.Conduite',
      't.transit':'T.Transit',
      'generer_carte':'Génerer la carte',
      'enregisrer':'Enregisrer',
      //popusp add alt long  map
      'ajout_longitude_latitude':'Ajout de longitude latitude',
      'merci_positionner_icone_carte':'Merci de positionner l\'icone sur la carte',
      'ajout_longitude_manuellement':'Ajout de longitude manuellement',
       //add greo point component
      'pl_geographique':'PL Geographique',
      'province':'Province',
      'zone':'Zone',
      'voyage_cree_avec_succes_avec_numero':'Le voyage est créé avec succés avec le numero',
      'validation':'Validation',
      'voulez-vous_planifier_voyatge':'Voulez-vous planifier ce voyatge',

  // //trip/create
  'TypeTrip': 'Type de voyage',
  'chooseCommand':'Choisir une/des commande(s)',
  'addOrder':'Ajouter une commande',
  'PointsDepartureArrival':'Points de départ / arrivé',
  'totalDriving':'Total conduite',
  'totalTransit':'Total transit',
  ////////////////////////////

  // Traduction Moncef

  // +---------------------------+
  // | - Globale                 |
  // +---------------------------+

  // Buttons
  'global.btn.valid':'Valider',
  'global.btn.cancel':'Annuler',
  'global.btn.add':'Ajouter',
  'global.btn.edit':'Modifier',
  'global.btn.delete':'Supprimer',
  'global.btn.save':'Enregistrer',
  'global.btn.filter':'Filtrer',
  'global.btn.close':'Fermer',
  'global.btn.next':'Suivant',
  'global.btn.back':'Retour',

  // Listes
  'global.details':'Détails',
  'global.from':'De',
  'global.to':'À',
  'global.date':'Le',
  'global.point.title':'Ajout point de chargement / déchargement',
  'global.point.search.placeholder':'Rechercher un point ...',
  'global.point.chargement':'Point de chargement',
  'global.point.dechargement':'Point de déchargement',
  'global.points.chargement':'Points de chargement',
  'global.points.dechargement':'Points de déchargement',

  // Formulaire / Table
  'global.table.firstname':'Name',
  'global.table.lastname':'Prénom',
  'global.table.job':'Profession',
  'global.table.tel':'Tél',
  'global.table.fax':'Fax',
  'global.table.email':'Email',
  'global.table.site':'Site Web',
  'global.table.adress':'Adresse',
  'global.table.city':'Ville',
  'global.table.code':'Code postale',
  'global.table.country':'Pays',
  'global.table.nif':'NIF',
  'global.table.client':'Client',
  'global.table.num':'Num',
  'global.table.zone':'Zone',
  'semi_r':'Semi-remorque',
  'chargement':'Chargement',
  'dechargement':'Déchargement',

  // +---------------------------+
  // | - Commandes               |
  // +---------------------------+

  // Liste des commandes
  'orders.breadcrumb.title':'Liste des commandes',
  'orders.menu.title':'Gestion des commandes',
  'orders.filter.order.num':'Numéro de commande :',
  'orders.filter.client':'Client :',
  'orders.list.details':'Détails',
  'orders.filter.btn2':'Filtrer',

  // Nouvelle commandes
  'order.create.breadcrumb.title':'Nouvelle commandes',
  'order.create.order.type':'Type de commande :',
  'order.create.remorque.type':'Type de remorque :',
  'order.create.client':'Choisir le(s) Client(s) :',
  'order.create.points.title':'Points de chargement / déchargement',
  'order.create.points.chargement':'Chargement',
  'order.create.points.dechargement':'Déchargement',
  'order.create.trajects.title':'Trajets',
  'order.create.trajects.truck':'Routier',
  'order.create.trajects.maritime':'Martime',
  'order.create.trajects.total.km':'Total KM',
  'order.create.trajects.total.conduite':'Total Conduite',
  'order.create.trajects.total.transit':'Total Transit',
  'order.create.recap.title':'Récapitulatif',

  // Ajout point Model
  'order.model.point.latlong':'Latitude, Longitude :',
  'order.model.point.date.start':'Date de début',
  'order.model.point.date.end':'Date de fin',
  'order.model.point.timepicker':'Sélectionner une date',

  // +---------------------------+
  // | - Utilisateurs            |
  // +---------------------------+

  // Liste des utilisateurs
  'users.breadcrumb.title':'Listes des utilisateurs',
  'users.filter.user.num':'Numéro / Nom utilisateur :',
  'users.filter.module':'Par Module :',
  'users.filter.access':'Par Accès :',
  'users.access':'Liste des accès',
  'users.list.msg':'Envoyer un message',
  'users.list.details':'Détails/Editer',

  // Détail utilisateur
  'user.detail.description':'Description',
  'user.detail.access.module.':'Module',
  'user.detail.access.read':'Lecteur',
  'user.detail.access.update':'Modification',
  'user.detail.access.delete':'Suppression',

  // +---------------------------+
  // | - Clients                 |
  // +---------------------------+

  // Liste des clients

  // Détails du client
  'client.breadcrumb.title':'Détails du client',
  'client.detail.domaine':'Domaine d\'activité :',
  'client.detail.contact.title':'Contact',
  'client.detail.contact.table.':'Contact',
  'client.detail.routes.title.':'Routes client',
  'client.detail.routes.btn':'Ajouter / Supprimer des routes',
  'client.detail.routes.table.departement':'point. Dpto',
  'client.detail.routes.table.provaince':'Dpto/Provaince',

  /** ======================= Permission ================================ **/
  'permission.route':'Gestion des routes',
  'permission.new_trip':'Nouveau Voyage',
  'permission.commande':'Gestion des commandes',
  'permission.user':'Gestion des utilisateurs',
  'permission.role':'Gestion des roles',
  'permission.client':'Gestion des clients',
  'permission.line':'Liste des trajets',
  'permission.conductor':'Gestion des chauffeurs',
  'permission.tractor':'Gestion des Remorques',
  'permission.remorque':'Gestion des tracteurs',
  'permission.sr_control':'Points de contrôle',
  'permission.reclamation':'Réclamations',
  'permission.dispo':' Disponibilité',
  'permission.statistic':'Statistiques',
  'permission.config':'Configurations',
  'permission.trip':'Liste des voyages',

  'permission.lecture':'Lecteur',
  'permission.modification':'Modification',
  'permission.creation':' Création',
  'permission.suppression':'Suppression',
  'permission.list.acces':'Liste des accès',
  'permission.prestataire':'Liste des prestataires',
  /** ======================= End Permission ================================ **/

  ' Disponibilité':' Disponibilité',
  'Nouveau Voyage':'Nouveau Voyage',
  'Disponibilité des moyens':'Disponibilité des moyens',
  'Gestion des roles':'Gestion des rôles',
  'Gestion des routes':'Gestion des routes',

  //Client
  'slug_client' : '',
};
